module.exports = __webpack_public_path__ + "static/media/exterior_3.0337c17a.jpeg";